import { takeLatest, call } from 'redux-saga/effects';

import { coreAPI } from 'utils/request';
import { SEPARATE_FOLIOS } from '../constants';
import { showErrorNotification } from '@aha/utils';
import NProgress from 'nprogress';

function* doSeparateFolios({ bid, fid, body, resolve, reject }) {
  yield call(NProgress.start);
  try {
    yield call(
      coreAPI.post,
      `v1/pms/bookings/${bid}/folios/${fid}/separate`,
      body,
    );
    resolve();
  } catch (err) {
    showErrorNotification('Fail to separate folios', err);
    reject();
  }
  yield call(NProgress.done);
}

export function* watchSeparateFolios() {
  yield takeLatest(SEPARATE_FOLIOS, doSeparateFolios);
}
